import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import Button from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import useReceiptDetails from 'src/hooks/useReceiptDetails';

const SaveReceipt = () => {
  const { errorList, infosList, isSaveDisabled, isSaving, saveReceiptDetails, isInProgress } =
    useReceiptDetails();

  return (
    <div className="w-[200px] flex items-center gap-1">
      <div className="w-[90px]">
        <PopUp
          show={isSaveDisabled}
          popupAlign={{ horizontal: 'left', vertical: 'top' }}
          anchorAlign={{ horizontal: 'left', vertical: 'bottom' }}
          content={
            <div className="m-1 max-w-[350px]">
              <PopUpContentWrapper type="Error" contents={errorList} />
              <PopUpContentWrapper type="Information" contents={infosList} />
            </div>
          }
        >
          {isInProgress && (
            <Button
              disabled={isSaveDisabled}
              onClick={() => saveReceiptDetails(true)}
              loading={isSaving}
            >
              Save
            </Button>
          )}
        </PopUp>
      </div>
    </div>
  );
};

export default SaveReceipt;
